<template>
    <div v-show="message">
        <p class="text-sm text-red-600">
            {{ message ? message.charAt(0).toUpperCase() + message.slice(1) : '' }}
        </p>
    </div>
</template>

<script>
    export default {
        props: ['message']
    }
</script>
